export const SLICE_NAME = "userActivity";
